import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { createStore, applyMiddleware, compose } from "redux";
import * as serviceWorker from "./serviceWorker";
import reducers from "./redux store/reducers";
import { loadState, saveState } from "./utils/persistState";
import throttle from "lodash/throttle";
import { saveAuthToken } from "./services/socketIO";

import "./theme/tailwind.css";
// import "./index.css";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedState = loadState();

export const store = createStore(
  reducers,
  { ...persistedState },
  composeEnhancers(applyMiddleware(thunk))
);

store.subscribe(
  throttle(() => {
    saveState({
      login: store.getState().login,
      theme: store.getState().theme,
      salesPersonToEdit: store.getState().salesPersonToEdit,
      vendorToEdit: store.getState().vendorToEdit,
    });
  }, 1000)
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
